/* eslint-disable */
import 'fullpage.js/vendors/scrolloverflow';
import fullpage from 'fullpage.js';
import './fullPage.scss';

// When using fullPage extensions replace the previous import
// of fullpage.js for this file
// import fullpage from 'fullpage.js/dist/fullpage.extensions.min';


document.addEventListener('DOMContentLoaded', () => {
  const isEditMode = document.documentElement.classList.contains('ccm-edit-mode');
  if (isEditMode) {
    return $('#myFullpage .section').addClass('active is-active fp-section fp-completely fp-disabled');
  }

  const sections = document.querySelectorAll('#myFullpage .section');
  const anchors = [];
  for (let i = 0; i < sections.length; i++) {
    // const h2 = sections[i].querySelector('h2');
    // const anchor = h2 ? encodeURI(h2.textContent) : String(i);
    anchors.push(String(i));
  }

  // fix hash navigation
  const el = document.getElementById('myFullpage');
  const arr = location.hash.split('#');
  const hash = arr[1];
  if (el && hash && isNaN(parseInt(hash))) {
    const seekedEl = document.getElementById(hash);
    if (seekedEl) {
      const section = seekedEl.closest('#myFullpage .section');
      if (section) {
        const index = Array.prototype.indexOf.call(sections, section);
        if (index > 0) {
          location.hash = `#${index}`;
        }
      }
    }
  }

  new fullpage('#myFullpage', {
    anchors,
    navigation: true,
    scrollOverflow: true,

    // fix for clicks inside of slides
    scrollOverflowOptions: {
      preventDefault: false,
    },

    licenseKey: '225CED92-149B4C76-9E008474-B1DBAC84',
    responsiveWidth: 1024,
    scrollingSpeed: 750,

    afterRender() {
      const banner = document.querySelector('.main-banner');
      banner.classList.add('loaded');
    },

    onLeave(origin, destination, direction) {
      if (origin) {
        const el = document.querySelector('[data-scroll-class=header_inverse]');
        if (origin.index === 0) {
          el.classList.add('header_inverse');
        }
        destination.item.classList.add('is-active');

        if (origin.index === 1 && direction === 'up') {
          el.classList.remove('header_inverse');
        }


        const navDots = document.getElementById('fp-nav');

        if (destination.item.classList.contains('light-background')) {
          navDots.classList.add('darker');
        } else {
          navDots.classList.remove('darker');
        }

        if (!destination.isLast === true && !origin.isLast === true) {
          const bodyEl = document.getElementsByTagName('body')[0];
          bodyEl.classList.add('fullpage__animate');
        }
        
        const video = destination.item.querySelector('video[data-desktop-autoplay]');
        if (video && !window.isMobile.any) {
          video.play();
        }
      }
    },

    afterLoad(origin, destination, direction) {
      if (origin) {
        const bodyEl = document.getElementsByTagName('body')[0];
        bodyEl.classList.remove('fullpage__animate');
      }
    },

  });
});
